import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import {Container, Row, Col, CardGroup, Card, CardHeader, CardBody} from 'reactstrap';

import { firebase } from '../firebase';

import {connect} from 'react-redux';
import {compose} from 'recompose';

import { loadDepartureSchedules } from '../actions/departureScheduleActions';
import * as departureScheduleActions from '../actions/departureScheduleActions';

const withDepartureSchedules = (Component) => {
  class WithDepartureSchedules extends React.Component {
	  constructor(props) {
	    super(props);
		
	    this.state = {
			departureSchedules: props.departureSchedules
	    };
	  }

      getChildContext() {
		  return {
			  departureSchedules: this.state.departureSchedules
          };
      }

  	componentWillReceiveProps(nextProps) {
		this.setState({ departureSchedules: nextProps.departureSchedules, departureSchedulesCount: nextProps.departureSchedulesCount });
  	}
	
	  componentDidMount() {
  		this.context.store.dispatch(loadDepartureSchedules('deviceId', this.context.authToken));
	  }

    render() {
		return (
			<Component {...this.props} departureSchedules={this.state.departureSchedules}/>
		);
    }
  }
  
  WithDepartureSchedules.contextTypes = {
	  authUser: PropTypes.object.isRequired,
	  authToken: PropTypes.string.isRequired,
	  store: PropTypes.object.isRequired
  }

  WithDepartureSchedules.childContextTypes = {
	  departureSchedules: PropTypes.array
  };

  return compose(
	  connect(mapStateToProps, mapDispatchToProps),
	  withRouter
  )(WithDepartureSchedules);
}

function mapStateToProps(state, ownProps) {
    return {
    	departureSchedules: state.departureSchedules
    };
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(departureScheduleActions, dispatch)
	}
}

export default withDepartureSchedules;



// WEBPACK FOOTER //
// ./src/components/withDepartureSchedules.js